import type { AccountLookup } from "../lib/gboModels";
import { normalizeCustomerAccountCode } from "../lib/lookupCode";
import { gboApi } from "./gboApiBase";

export type AccountQueryArg = {
  customerCode: string;
};

export const accountApi = gboApi.injectEndpoints({
  endpoints: (builder) => ({
    getAccount: builder.query<AccountLookup, AccountQueryArg>({
      query: ({ customerCode }) => ({
        url: `accounts/${encodeURIComponent(normalizeCustomerAccountCode(customerCode))}`,
      }),
      providesTags: (_result, _error, { customerCode }) => [
        { type: "Account", id: normalizeCustomerAccountCode(customerCode) },
      ],
    }),
  }),
});

export const { useGetAccountQuery } = accountApi;
